export const ROUTE_MAP: Record<string, {url: string, operationKlass: string}> = {
  'Client::Equipment': {
    url: '/equipments', 
    operationKlass: 'Client::Equipments::Show'
  },
  'Client::CompanyBranch': {
    url: '/company-branches', 
    operationKlass: 'Client::CompanyBranches::Show'
  },
}